import { Values } from '@lib/interfaces/form';
import _get from 'lodash/get';
import {
  ColorEnum,
  SectorCreateInputObject,
  SectorUpdateInputObject,
} from 'graphql-common';
import SectorFieldNames from '@lib/enums/fieldNames/sectorFieldNames';
import mergeAndUnlinkMultiSelectValues, {
  Item,
} from '@lib/utils/mergeAndUnlinkMultiSelectValues';
import removePropertiesTypeDeep from '@lib/utils/removePropertiesTypeDeep';
import removeTypenameDeep from '@lib/utils/removeTypenameDeep';
import getNormalizedMapData from '@lib/components/Map/utils/getNormalizedMapData';

function getOptions(values: Values, name: string) {
  return ((_get(values, name, []) as Item[]) || []).map(({ value }) => ({
    id: `${value}`,
  }));
}

export default function getPreparedDataFromValues(args: {
  values: Values;
  prevValues: Values;
}): SectorCreateInputObject | SectorUpdateInputObject {
  const { values, prevValues } = args;
  const user = _get(values, [SectorFieldNames.UserId]);
  const userId = user
    ? (_get(values, [SectorFieldNames.UserId, 'value']) as string)
    : null;
  const sites = getOptions(values, SectorFieldNames.Sites);
  const prevSites = getOptions(prevValues, SectorFieldNames.Sites);
  const userMemberships = getOptions(values, SectorFieldNames.UserMemberships);
  const prevUserMemberships = getOptions(
    prevValues,
    SectorFieldNames.UserMemberships,
  );
  const locationBoundaryValue = values[SectorFieldNames.LocationGeojson];
  const locationBoundary = locationBoundaryValue
    ? {
        geojson: getNormalizedMapData(
          removePropertiesTypeDeep(removeTypenameDeep(locationBoundaryValue)),
        ),
      }
    : null;
  return {
    name: _get(values, SectorFieldNames.Name) as string,
    code: _get(values, SectorFieldNames.Code) as string,
    description: _get(values, SectorFieldNames.Description) as string,
    color: _get(values, [SectorFieldNames.Color, 'value']) as ColorEnum,
    userId,
    sites: mergeAndUnlinkMultiSelectValues(prevSites, sites),
    locationBoundary,
    userMemberships: mergeAndUnlinkMultiSelectValues(
      prevUserMemberships,
      userMemberships,
    ),
  };
}
